/* Subscription page sections: swipe slider dots, consistency chart, habit buttons. */
(() => {
  if (window.ddSub) return;
  window.ddSub = true;

  const slider = (track) => {
    const dots = track.nextElementSibling;
    if (!dots || !dots.classList.contains('dds-dots')) return;
    const items = track.children;
    const step = () => (items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : 1);
    const current = () => Math.round(track.scrollLeft / step());
    const build = () => {
      const visible = Math.max(1, Math.round(track.clientWidth / step()));
      const pages = track.scrollWidth > track.clientWidth + 2 ? items.length - visible + 1 : 0;
      dots.hidden = pages < 2;
      dots.innerHTML = '';
      for (let i = 0; i < pages; i++) {
        const b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Slide ' + (i + 1));
        b.onclick = () => track.scrollTo({ left: i * step(), behavior: 'smooth' });
        dots.append(b);
      }
      mark();
    };
    const mark = () => [...dots.children].forEach((b, i) => b.classList.toggle('on', i === Math.min(current(), dots.children.length - 1)));
    track.addEventListener('scroll', () => requestAnimationFrame(mark), { passive: true });
    new ResizeObserver(build).observe(track);
  };

  const chart = (root) => {
    const card = root.querySelector('.dds-chart');
    if (!card) return;
    const pts = card.querySelectorAll('.pt');
    const phases = root.querySelectorAll('.phase');
    const set = (p) => {
      phases.forEach((el, i) => el.classList.toggle('on', i + 1 === p));
      pts.forEach((c) => c.classList.toggle('on', +c.dataset.p === p));
    };
    pts.forEach((c) => ['click', 'mouseenter'].forEach((ev) => c.addEventListener(ev, () => set(+c.dataset.p))));
    phases.forEach((el, i) => el.addEventListener('click', () => set(i + 1)));
    set(1);
    new IntersectionObserver((en, o) => {
      if (en[0].isIntersecting) { card.classList.add('in'); o.disconnect(); }
    }, { threshold: 0.35 }).observe(card);
  };

  const habits = (root) => {
    const btns = root.querySelectorAll('.habit');
    const status = root.querySelector('.habit-status');
    if (!btns.length || !status) return;
    const base = status.textContent;
    btns.forEach((h) => h.addEventListener('click', () => {
      h.setAttribute('aria-pressed', h.getAttribute('aria-pressed') !== 'true');
      const done = root.querySelectorAll('.habit[aria-pressed="true"]').length;
      status.textContent = !done ? base
        : done < btns.length ? status.dataset.progress.replace('[done]', done).replace('[total]', btns.length)
        : status.dataset.complete;
    }));
  };

  const init = (scope) => {
    scope.querySelectorAll('.dds-track').forEach(slider);
    scope.querySelectorAll('.dds').forEach((root) => { chart(root); habits(root); });
  };

  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
